module.exports = __webpack_public_path__ + "img/پیچیده-(2).312748a8.png";